module.exports = __webpack_public_path__ + "static/scale-model-of-printers-alley-in-nashville-tennessee-2dfe3de811a9f14a557a8b77b2d197e3.png";